import { useRef, useState, type FunctionComponent } from 'react'
import styled from 'styled-components'
import {
  ApexCharts,
  ApexChartsProp,
  type ApexChartOptions,
} from '@/components/common/apex-charts'

interface ApexChartsYAxisLabelsProps extends ApexChartsProp {
  options: ApexChartOptions
}

const ApexChartsYAxisLabels: FunctionComponent<ApexChartsYAxisLabelsProps> = ({
  options,
  ...props
}) => {
  const containerRef = useRef<HTMLDivElement>(null)

  const [width, setWidth] = useState(0)

  const chartOptions: ApexChartOptions = {
    ...options,
    chart: {
      ...options.chart,
      id: `${options.chart?.id}_'YAxisLabels'}`,
      offsetX: 0,
      events: {
        updated: () => {
          const elementWidth =
            containerRef.current
              ?.querySelector('.apexcharts-yaxis-label')
              ?.getBoundingClientRect().width ?? 0

          setWidth(elementWidth * 2 + 5)
        },
      },
    },
    fill: {
      opacity: 0,
    },
    tooltip: {
      enabled: false,
    },
    grid: {
      show: false,
    },
    yaxis: {
      ...options.yaxis,
      labels: {
        ...options.yaxis?.labels,
        show: true,
      },
    },
  }

  return (
    <Container $width={width} ref={containerRef}>
      <ApexCharts {...props} options={chartOptions} />
    </Container>
  )
}

const Container = styled.div<{ $width?: number }>`
  overflow: hidden;
  width: ${({ $width = 0 }): number => $width}px;
  min-width: 30px;

  .apexcharts-inner {
    display: none;
  }
`

export default ApexChartsYAxisLabels
